import API_URLS from '@/api/API_URLS.js';
import { httpGet, httpPost } from '@/api/request';
const getInfo = () => httpGet(API_URLS.INFO);
const getOrderStatus = () => httpGet(API_URLS.ORDER_STATUS);
const getOrder = params => httpPost(API_URLS.ORDER, params);
const getComponent = params => httpPost(API_URLS.COMPONENT, params);
const addToShoppingCar = params => httpPost(API_URLS.ADDCAR, params);
const removeFromShoppingCar = params => httpPost(API_URLS.REMOVE_CAR, params);
const getListShoppingCar = params => httpPost(API_URLS.GETCAR, params);
const submitShoppingCar = params => httpPost(API_URLS.SUBMITCAR, params);
const getAllComponent = () => httpGet(API_URLS.ALL_COMPONENT);
const getProductDetails = params => httpPost(API_URLS.PRODUCT_DETAIL, params);
const editPersonalMsg = params => httpPost(API_URLS.PERSONAL_MSG, params);
const getHomePage = () => httpGet(API_URLS.HOME_CYCLE);
const getSolution = () => httpGet(API_URLS.SOLUTION);
const getHomeMenu = () => httpPost(API_URLS.HOME_MENU, {
  lang_version: 'cn'
});
const getLabel = () => httpGet(API_URLS.RECOMMEND_LABEL);
const queryLabel = params => httpGet(API_URLS.QUERY_LABEL, params);

// 数据接口相关
const getInterfaceDetail = params => httpPost(API_URLS.INTERFACE_DETAIL, params); // 查询接口详情
const interfaceDebug = params => httpPost(API_URLS.INTERFACE_DEBUG, params); // 接口调试
const getAllInterfaceCategory = params => httpGet(API_URLS.ALL_INTERFACE_CATEGORY, params); // 查询全部分类
const getAllInterfaceByCategory = params => httpGet(API_URLS.ALL_INTERFACE_BY_CATEGORY, params); // 查询指定分类全部接口
const getProductList = params => httpGet(API_URLS.PRODUCT_MENU, params); // 查询产品类型
const getAssiationInterface = params => httpGet(API_URLS.QUERY_INTERFACE, params); // 查询关联接口
//首页banner
const getProductUse = params => httpGet(API_URLS.PRODUCT_USE, params); // 获取试用产品列表
const checkPower = params => httpPost(API_URLS.PRODUCT_ROLE, params); // 产品权限
// 语音合成
const getSpeechModelList = params => httpPost(API_URLS.TEXT_TO_SPEECH_MODEL_LIST, params, {
  headers: {
    'Content-type': 'application/x-www-form-urlencoded'
  }
});
const composeSpeech = params => httpPost(API_URLS.TEXT_TO_SPEECH_COMPOSE, params, {
  headers: {
    'Content-type': 'application/x-www-form-urlencoded'
  }
});
export { getInfo, getOrderStatus, getOrder, getComponent, addToShoppingCar, removeFromShoppingCar, getListShoppingCar, submitShoppingCar, getProductDetails, getAllComponent, getInterfaceDetail, interfaceDebug, getAllInterfaceByCategory, getAllInterfaceCategory, editPersonalMsg, getHomePage, getSolution, getProductList, getHomeMenu, getSpeechModelList, composeSpeech, getLabel, queryLabel, getAssiationInterface, getProductUse, checkPower };